module.exports = __webpack_public_path__ + "static/media/Illustration_Settings.27b4175e.svg";